/* eslint-disable import/no-cycle */
import { handleActions } from 'redux-actions';

import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';

export const initialState = {
  errorMessage: null,
  mobileNumber: null,
};

const reducer = handleActions(
  {
    [actionTypes.SAVE_MOBILE]: (state, { payload }) => ({
      ...state,
      mobileNumber: payload.mobileNumber,
    }),
    [actionTypes.UPDATE_ERROR_MESSAGE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX),
);

export default reducer;
